<template>
    <page-heading page-title="Kontakt"/>

    <div class="flex justify-center flex-row">
        <div class="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">


            <div class="mt-10 sm:mt-0">
                <div class="md:grid md:grid-cols-2 md:gap-6">

                    <div class="mt-5 md:mt-0 md:col-span-2">
                        <form action="#" ref="form1" method="POST" @submit.prevent="submit"
                              enctype="multipart/form-data"
                              accept-charset="UTF-8">
                            <div class="shadow overflow-hidden sm:rounded-md">


                                <div class="px-4 py-5 bg-white sm:p-6">

                                    <div class="grid grid-cols-6 gap-6">
                                        <div class="col-span-6 sm:col-span-6">
                                            <label for="title"
                                                   class="block text-sm font-medium text-gray-700">Wybierz dział, do
                                                którego chcesz skierować wiadomość</label>
                                            <select id="type" name="type" autocomplete="title_name" v-model="type"
                                                    class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                    required>
                                                <template v-for="typeDescription in typeDescriptions"
                                                          :key="typeDescription.id">
                                                    <option :value="typeDescription.type">{{ typeDescription.title }}
                                                    </option>
                                                </template>
                                            </select>
                                        </div>

                                        <div class="col-span-6 sm:col-span-6">
                                            <i>{{ getTypeDescription() }}</i>

                                            <template v-if="type==='hr'">
                                                <p class="mt-4" v-if="jobOfferId">
                                                    <small class="block font-bold text-indigo-500">Aplikacja na
                                                        stanowisko: </small>
                                                    <span
                                                        class="text-sm font-bold text-gray-500">{{
                                                            jobOfferTitle
                                                        }}</span>
                                                    <input type="hidden" name="employee_offer_id" :value="jobOfferId"/>

                                                    <router-link :to="{ name: 'jobs'}"
                                                                 class="ml-4 cursor-pointer inline-flex items-center px-2.5 py-1 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                                        Wybierz inne stanowisko
                                                    </router-link>
                                                </p>
                                                <p class="text-center p-4" v-else>
                                                    <router-link :to="{ name: 'jobs'}"
                                                                 class="ml-4 cursor-pointer inline-flex items-center px-2.5 py-1 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                                        Zobacz oferty pracy
                                                    </router-link>
                                                </p>
                                            </template>

                                        </div>

                                        <template v-if="type ==='b2b'">
                                            <div class="col-span-6 sm:col-span-4">
                                                <label for="street-address"
                                                       class="block text-sm font-medium text-gray-700">Nazwa
                                                    firmy</label>
                                                <input type="text" v-model="company_name" name="company_name"
                                                       id="company-name"
                                                       autocomplete="organization"
                                                       class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                                            </div>

                                            <div class="col-span-6 sm:col-span-2">
                                                <label for="city"
                                                       class="block text-sm font-medium text-gray-700">NIP</label>
                                                <input type="text" v-model="tax_id" name="tax_id" id="tax_id"
                                                       autocomplete=""
                                                       class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                                            </div>
                                        </template>

                                        <div class="col-span-6 sm:col-span-3">
                                            <label for="first-name"
                                                   class="block text-sm font-medium text-gray-700">Imię</label>
                                            <input type="text" v-model="first_name" name="first_name" id="first-name"
                                                   autocomplete="given-name"
                                                   class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md capitalize"/>
                                        </div>

                                        <div class="col-span-6 sm:col-span-3">
                                            <label for="last-name" class="block text-sm font-medium text-gray-700">Nazwisko</label>
                                            <input type="text" v-model="last_name" name="last_name" id="last-name"
                                                   autocomplete="family-name"
                                                   class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md capitalize"/>
                                        </div>

                                        <div class="col-span-6 sm:col-span-4">
                                            <label for="email-address" class="block text-sm font-medium text-gray-700">Adres
                                                e-mail</label>
                                            <input type="text" v-model="email" name="email"
                                                   id="email"
                                                   autocomplete="email"
                                                   class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                                        </div>

                                        <div class="col-span-6 sm:col-span-2">
                                            <label for="phone"
                                                   class="block text-sm font-medium text-gray-700">Telefon</label>
                                            <input type="text" v-model="phone" name="phone"
                                                   id="phone"
                                                   autocomplete="phone"
                                                   class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                                        </div>


                                        <template
                                            v-if="type==='b2b'|| title==='hr'">
                                            <!--Address-->
                                            <div class="col-span-6">
                                                <label for="street-address"
                                                       class="block text-sm font-medium text-gray-700">Ulica</label>
                                                <input type="text" v-model="street_address" name="street_address"
                                                       id="street-address"
                                                       autocomplete="street-address"
                                                       class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                                            </div>

                                            <div class="col-span-6 sm:col-span-6 lg:col-span-2">
                                                <label for="city"
                                                       class="block text-sm font-medium text-gray-700">Miejscowość</label>
                                                <input type="text" v-model="city" name="city" id="city"
                                                       autocomplete="address-level2"
                                                       class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                                            </div>

                                            <div class="col-span-6 sm:col-span-3 lg:col-span-2">
                                                <label for="region" class="block text-sm font-medium text-gray-700">Województwo</label>
                                                <input type="text" v-model="region" name="region" id="region"
                                                       autocomplete="address-level1"
                                                       class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                                            </div>

                                            <div class="col-span-6 sm:col-span-3 lg:col-span-2">
                                                <label for="postal-code"
                                                       class="block text-sm font-medium text-gray-700">Kod
                                                    pocztowy</label>
                                                <input type="text" v-model="postal_code" name="postal_code"
                                                       id="postal-code"
                                                       autocomplete="postal-code"
                                                       class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                                            </div>
                                        </template>


                                        <!-- Message-->
                                        <div class="col-span-6 sm:col-span-6 lg:col-span-6">
                                            <label for="content" class="block text-sm font-medium text-gray-700">
                                                Wiadomość </label>
                                            <div class="mt-1">
                                            <textarea id="content" v-model="content" name="content" rows="3"
                                                      class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 mt-1 block w-full sm:text-sm border border-gray-300 rounded-md"
                                                      placeholder="Wpisz treść wiadomości" required/>
                                            </div>
                                            <!--                                            <p class="mt-2 text-sm text-gray-500">Message content</p>-->
                                        </div>

                                        <!--FILES-->
                                        <div class="col-span-6 sm:col-span-6 lg:col-span-6">
                                            <label class="block text-sm font-medium text-gray-700"> Załączniki </label>
                                            <div v-if="showDragAndDropArea"
                                                 @dragover.stop.prevent="handleDragOver($event)"
                                                 @drop.stop.prevent="processFile($event)"
                                                 class="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                                                <div class="space-y-1 text-center">
                                                    <svg class="mx-auto h-12 w-12 text-gray-400" stroke="currentColor"
                                                         fill="none" viewBox="0 0 48 48" aria-hidden="true">
                                                        <path
                                                            d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                                                            stroke-width="2" stroke-linecap="round"
                                                            stroke-linejoin="round"/>
                                                    </svg>
                                                    <div class="flex text-sm text-gray-600">
                                                        <label for="file-upload"
                                                               class="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
                                                            <span>Dodaj załączniki</span>
                                                            <input id="file-upload" name="file_upload" type="file"
                                                                   class="sr-only" accept=".pdf,image/*"
                                                                   @change="processFile($event)" multiple/>
                                                        </label>
                                                        <p class="pl-1">albo przeciągnij i upuść</p>
                                                    </div>
                                                    <p class="text-xs text-gray-500">PDF, DOC, ODS, PNG, JPG, GIF do
                                                        10MB</p>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <label for="file-upload"
                                                       class="inline-block bg-white mt-1 py-2 px-3 border border-gray-300 rounded-md shadow-sm text-sm leading-4 font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                                    <span>Dodaj załączniki</span>
                                                    <input id="file-upload" name="file_upload" type="file"
                                                           class="sr-only" accept=".pdf,image/*"
                                                           @change="processFile($event)" multiple/>
                                                </label>
                                                <p class="mt-1 text-xs text-gray-500">PNG, JPG, GIF up to 10MB</p>
                                            </div>
                                            <ul v-if="filesList.length" class="text-xs">
                                                <li v-for="(file, index) in filesList" :key="file.name + index">
                                                    <strong>{{ file.name }}</strong>, {{ file.size }} bytes
                                                </li>
                                            </ul>
                                        </div>

                                        <!--RODO-->
                                        <div class="col-span-6">
                                            <div class="mt-6 flex space-x-2">
                                                <div class="flex items-center h-5">
                                                    <input id="terms" name="terms" type="checkbox"
                                                           class="h-4 w-4 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500"
                                                           required>
                                                </div>
                                                <label for="terms" class="text-sm text-gray-500">Wyrażam zgodę na
                                                    przetwarzanie moich danych osobowych do celów obsługi wiadomości
                                                    kontaktowej</label>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <div class="px-4 py-3 bg-gray-50 text-right sm:px-6">
                                    <button type="submit"
                                            class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                        Wyślij
                                    </button>
                                </div>

                            </div>
                        </form>
                    </div>
                </div>
            </div>


        </div>
    </div>

</template>

<script>
// ____________________________________________
// TODO: ADAM Post pod ścieżkę https://cloudpanel.pl/api/uchowanca/storeMessage - zwraca:
// 'result' => $name . ' dziękujemy za wiadomość!',
//Formularz z plikiem (wielokrotny załacznik). Gdzie obsługa dopuszczalnych typów (frontend czy backend czy oba)? Tylko zdjęcia i PDF. Czy drag & drop też działa z PDF?
//Jak ma być obsłużona obsługa błędów w formularzu?
//Z racji że boty takie formularza atakują dadane było proste pole z zadaniem matematycznym 2+7 i już nie się wykładały. Czy implementacja Captcha to skomplikowana sprawa?
//+ odpowiedź Wywołanie komunikatu o wysłaniu wiadomości (result) do komponentu Notification (powinien zniknąc powiedzmy po 7 sekundach).
// ____________________________________________

import PageHeading from "../components/layout/PageHeading";

export default {
    name: "ContactPage",
    components: {PageHeading},
    props: {
        type: {
            type: String,
            default: 'customerService',
        },
        jobOfferId: {
            default: null,
        },
        jobOfferTitle: {
            default: null,
        },
        orderId: {
            default: null,
        },
    },
    data: () => ({
        typeDescriptions: [

            {
                id: 1,
                type: 'customerService',
                title: 'Dział obsługi klienta',
                description: 'Zgłoszenie reklamacji i uwagi dotyczące obsługi.',
            },
            {
                id: 2,
                type: 'b2b',
                title: 'Dział handlowy',
                description: 'Przyjmowanie ofert handlowych, obsługa spraw związanych z dostawami i rozliczeniem zobowiązań.',
            },
            {
                id: 3,
                type: 'hr',
                title: 'Dział rekrutacji i obsługi pracowników',
                description: 'Zgłoszenia do pracy, realizacja postępowań rekrutacyjnych, obsługa spraw pracowników',
            },
            {
                id: 4,
                type: 'management',
                title: 'Zarząd firmy',
                description: 'Kontakt z zarządem firmy.',
            },
        ],
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        street_address: '',
        city: '',
        region: '',
        postal_code: '',
        content: '',
        tax_id: '',
        company_name: '',
        files: [],
        filesList: [],
        showDragAndDropArea: false,
        sizeLimit: 350 * 1024, // Łączny limit rozmiaru plików w bajtach
        currentFilesSize: 0,
    }),
    created() {
        // console.log(this.$route.params.jobOfferId);
        // Check for the various File API support.
        if (window.File && window.FileReader && window.FileList && window.Blob) {
            this.showDragAndDropArea = true;
        } else {
            // The File APIs are not fully supported in this browser.
            this.showDragAndDropArea = false;
        }
    },
    methods: {
        getTypeDescription() {
            //TODO: Gdy w router link są props to nie można ich usunąć na przykład gdy user zmienia typ formularza
            // this.$props.jobOfferId = null;
            // this.$props.jobOfferTitle = null;
            for (let i = 0; i < this.typeDescriptions.length; i++) {
                if (this.typeDescriptions[i].type === this.type) return this.typeDescriptions[i].description;
            }

            return this.typeDescriptions[0].description;
        },
        handleDragOver(event) {
            event.dataTransfer.dropEffect = 'copy';
        },
        processFile(event) {
            let files;
            if (event.target.tagName.toLowerCase() === 'input') {
                files = event.target.files;
            } else {
                files = event.dataTransfer.files;
            }

            for (var i = 0, f; f = files[i]; i++) {

                console.log(this.sizeLimit, this.currentFilesSize, f.size);
                if (this.sizeLimit - this.currentFilesSize - f.size > 0) {
                    this.filesList.push({
                        name: f.name,
                        size: f.size,
                    });
                    this.files.push(files[i]);
                    this.currentFilesSize += f.size;
                } else {
                    this.emitter.emit('notification', {
                        title: 'Niektóre pliki zostały pominięte',
                        message: `Możesz dodać pliki o łącznym rozmiarze do ${this.sizeLimit / 1024} KB.`,
                        type: 'warning'
                    });
                    break;
                }
            }
        },
        submit() {
            const formData = new FormData();
            formData.append('channel', 'uchowanca.pl');
            formData.append('type', this.type);
            formData.append(
                'first_name',
                String(this.first_name).charAt(0).toUpperCase() + String(this.first_name).slice(1)
            );
            formData.append(
                'last_name',
                String(this.last_name).charAt(0).toUpperCase() + String(this.last_name).slice(1)
            );
            formData.append('email', this.email);
            formData.append('phone', this.phone);
            formData.append('street_address', this.street_address);
            formData.append('city', this.city);
            formData.append('region', this.region);
            formData.append('postal_code', this.postal_code);
            formData.append('tax_id', this.tax_id);
            formData.append('company_name', this.company_name);
            formData.append('content', this.content);
            if (this.type === 'hr') {
                formData.append('employee_offer_id', this.jobOfferId); //usuwa jobOfferId, jeśli jest inny typ
            }
            //TODO: Dokończyć dodawanie ogłoszeń - np biznesowy temat współpracy i numer zamówienia z BOK
            // formData.append('order_id', this.order_id);
            // formData.append('announcement_id', this.announcement_id);
            // formData.append('files', this.files); //dodane — to tak nie zadziała

            for (let i = 0; i < this.files.length; i++) {
                formData.append(`files[${i}]`, this.files[i]);
            }

            fetch(`${window.cloudpanelapi}/uchowanca/storeMessage`, {
                method: 'POST',
                body: formData,
            })
                .then(response => response.json())
                .then(result => {
                    this.emitter.emit('notification', {
                        title: 'Wysyłka zakończona sukcesem!',
                        message: result.result,
                        type: 'info'
                    })
                    // this.$router.push("/")
                    //TODO Adam: Kasowanie załączników
                    // this.files = [];
                    // this.filesList = [];
                    this.$refs.form1.reset();
                })
                .catch(error => {
                    console.error('Error:', error);
                    this.emitter.emit('notification', {
                        title: 'Wystąpił błąd!',
                        message: error,
                        type: 'error'
                    })
                });
        }
    }
}
</script>

<style scoped>

</style>
